module.exports = __webpack_public_path__ + "static/media/trinity.455e6d64.png";